import { useEffect, useCallback } from "react";
import api from "../utils/api";
import { CHAVE_TOKEN } from "../utils/formata";

// Tira campos vazios pra não mandar ?tipo=&categoria= e o backend achar que é filtro
function limpar(filtros = {}) {
  const params = {};
  Object.entries(filtros).forEach(([chave, valor]) => {
    if (valor !== "" && valor !== null && valor !== undefined) params[chave] = valor;
  });
  return params;
}

export default function useContabilidade() {
  // Mesmo padrão do useHelp/useLead: garante o Bearer no F5 direto em /contabilidade,
  // antes do effect de carregamento da página (effects rodam na ordem de registro)
  useEffect(() => {
    const token = localStorage.getItem(CHAVE_TOKEN);
    if (token) {
      api.defaults.headers.Authorization = `Bearer ${token}`;
    }
  }, []);

  // ===== Lançamentos =====
  // Sem try/catch: o erro do axios sobe com .status/.response, que é o shape do useErroPadrao
  const listarLancamentos = useCallback(async (filtros) => {
    return api
      .get("/contabilidade/lancamento", { params: limpar(filtros) })
      .then((r) => r.data);
  }, []);

  const criarLancamento = useCallback(async (dados) => {
    return api.post("/contabilidade/lancamento", dados).then((r) => r.data);
  }, []);

  const atualizarLancamento = useCallback(async (id, dados) => {
    return api.put(`/contabilidade/lancamento/${id}`, dados).then((r) => r.data);
  }, []);

  const excluirLancamento = useCallback(async (id) => {
    return api.delete(`/contabilidade/lancamento/${id}`).then((r) => r.data);
  }, []);

  // ===== Contas a pagar / receber =====
  const listarContas = useCallback(async (filtros) => {
    return api
      .get("/contabilidade/conta", { params: limpar(filtros) })
      .then((r) => r.data);
  }, []);

  const criarConta = useCallback(async (dados) => {
    return api.post("/contabilidade/conta", dados).then((r) => r.data);
  }, []);

  const atualizarConta = useCallback(async (id, dados) => {
    return api.put(`/contabilidade/conta/${id}`, dados).then((r) => r.data);
  }, []);

  const excluirConta = useCallback(async (id) => {
    return api.delete(`/contabilidade/conta/${id}`).then((r) => r.data);
  }, []);

  const baixarConta = useCallback(async (id, dados) => {
    return api.post(`/contabilidade/conta/${id}/baixar`, dados).then((r) => r.data);
  }, []);

  const estornarConta = useCallback(async (id) => {
    return api.post(`/contabilidade/conta/${id}/estornar`, {}).then((r) => r.data);
  }, []);

  // ===== Fechamento mensal =====
  const consultarFechamento = useCallback(async (mes) => {
    return api
      .get("/contabilidade/fechamento", { params: { mes } })
      .then((r) => r.data);
  }, []);

  return {
    listarLancamentos,
    criarLancamento,
    atualizarLancamento,
    excluirLancamento,
    listarContas,
    criarConta,
    atualizarConta,
    excluirConta,
    baixarConta,
    estornarConta,
    consultarFechamento,
  };
}
